import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  InputLabel,
  Select,
  Input,
  FormControl,
  MenuItem,
  Divider
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { updateRouteStatus } from 'src/store/actions/RouteManagerActions';

function UpdateRouteStatus({ open, handleClose, item }) {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentItem(item);
  }, [item]);

  const handleUpdateRouteStatus = async (values) => {
    const { id } = values;
    setLoading(true);
    const response = await dispatch(
      updateRouteStatus(item?.id, values, profile)
    );
    if (response == 1) {
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle id="title">
        <Typography color="textPrimary" variant="h3">
          Update Route Status
        </Typography>
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={{
          status: `${currentItem?.status}`
          // id: `${currentItem?.id}`
        }}
        validationSchema={Yup.object().shape({
          status: Yup.number().max(255).required('Status is required')
        })}
        onSubmit={(values) => {
          handleUpdateRouteStatus(values);
          // navigate('/app/dashboard', { replace: true });
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <TextField
                error={Boolean(touched.status && errors.status)}
                fullWidth
                select
                helperText={touched.status && errors.status}
                margin="normal"
                name="status"
                onBlur={handleBlur}
                onChange={handleChange}
                required
                value={values.status}
                variant="outlined"
                size="small"
              >
                <MenuItem value="">Please select status</MenuItem>
                <MenuItem value={1}>Activate</MenuItem>
                <MenuItem value={0}>Deactivate</MenuItem>
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
              >
                {loading && <CircularProgress size="1.5rem" />}
                &nbsp; Update Status
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}

export default UpdateRouteStatus;
